/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCommissionStatementDtoFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, serializeCommissionStatementDto, serializeSubmitForReviewRequest, type CommissionStatementDto, type ErrorResponse, type InternalErrorResponse, type SubmitForReviewRequest } from '../../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/commissions/statements/{commissionStatementId}/submit-for-review
 */
export interface SubmitForReviewRequestBuilder extends BaseRequestBuilder<SubmitForReviewRequestBuilder> {
    /**
     * Moves a statement from Pending to InReview, the first step out of the status a statement is created in. Only a Pending statement can be submitted: one already in review, approved, disputed or paid is refused, and a disputed statement goes back into review through the return-to-review endpoint instead. `user` is required and is written into the statement's history against the change; it is recorded as sent and is not checked against the caller's identity. Amounts are unaffected — nothing is recalculated at any point in the workflow.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CommissionStatementDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: SubmitForReviewRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CommissionStatementDto | undefined>;
    /**
     * Moves a statement from Pending to InReview, the first step out of the status a statement is created in. Only a Pending statement can be submitted: one already in review, approved, disputed or paid is refused, and a disputed statement goes back into review through the return-to-review endpoint instead. `user` is required and is written into the statement's history against the change; it is recorded as sent and is not checked against the caller's identity. Amounts are unaffected — nothing is recalculated at any point in the workflow.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: SubmitForReviewRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SubmitForReviewRequestBuilderUriTemplate = "{+baseurl}/api/commissions/statements/{commissionStatementId}/submit-for-review";
/**
 * Metadata for all the requests in the request builder.
 */
export const SubmitForReviewRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SubmitForReviewRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCommissionStatementDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeSubmitForReviewRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
